export default __webpack_public_path__ + "static/media/BNB-white.ecba2925.svg";